import { render, staticRenderFns } from "./CreateTreatmentOptions.vue?vue&type=template&id=dee0db34&scoped=true"
import script from "./CreateTreatmentOptions.vue?vue&type=script&lang=js"
export * from "./CreateTreatmentOptions.vue?vue&type=script&lang=js"
import style0 from "./CreateTreatmentOptions.vue?vue&type=style&index=0&id=dee0db34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee0db34",
  null
  
)

export default component.exports